export default {
  "/swapForex/swapForexQuery": [
    {
      path: "/swapForex/swapForexDetail",
      name: "swapForexDetail",
      meta: {
        title: "换汇详情",
        showLink: true,
        hiddenTag: true,
        matchedPath: "/swapForex/swapForexQuery",
        visible: "1",
        operate: "0"
      }
    }
  ],
  "/swapForex/swapForex": [
    {
      path: "/payPassValid/rePayPassValid",
      name: "rePayPassValid",
      meta: {
        title: "验证支付密码",
        showLink: true,
        hiddenTag: true,
        matchedPath: "/swapForex/swapForex",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/common/result",
      name: "swapForexResult",
      meta: {
        title: "换汇成功",
        hiddenTag: true,
        matchedPath: "/swapForex/swapForex",
        visible: "1",
        operate: "0"
      }
    }
  ]
};
